/* @deprecated */
//this is going to be our javelina client library we use in any service that needs to make these calls
const axios = require('axios').default;
const constants = require('./constants.json');
const API_URL = process.env.JAVELINA_PROXY_API_URL || null;
const API_KEY = process.env.JAVELINA_PROXY_API_KEY || null;
axios.defaults.timeout = 30000;

/************* Config *************/

const loadConstants = () => {
    return constants
}

/************* Accumulators *************/

/**
 * @description returns a family accums object for a specific product and year
 * @param {String} employeeId the JV employeeId
 * @param {String} product Product ID - M=Medical, D=Dental, V=Vision, P-Perscription, H=HSA
 * @param {String} year Year - 2017, 2018, etc.
 */
const getFamilyAccums = async (employeeId, product, year) => {
    const params = {
        employeeId: employeeId,
        product: product,
        year: year
    }
    const response = await axios.get(`${API_URL}/eligibility/readAccumsByEmployeeIdProductYear`, {
        headers: {
            'x-api-key': API_KEY,
            'content-type': 'application/json'
        },
        params: params
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

/************* Authorizations *************/

/**
 * @description returns a list of a family by certificate number
 * @param {String} certificateNumber the family certificate number
 */
const createAuthorization = async (certificateNumber) => {
    const params = {
        certificateNumber: certificateNumber
    }
    const response = await axios.get(`${API_URL}/eligibility/searchMemberByCertificateNumber`, {
        headers: {
            'x-api-key': API_KEY,
            'content-type': 'application/json'
        },
        params: params
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

/**
 * @description returns a list of dependent referrals
 * @param {String} employeeId the JV employee Id
 * @param {String} depSeqNumber the dependent sequence number of the depenent
 */
const getDependentAuthorizations = async (employeeId, depSeqNumber) => {
    const params = {
        employeeId: employeeId,
        depSeqNum: depSeqNumber
    }
    const response = await axios.get(`${API_URL}/authorizations/listAuthorizationsByDependentNumber`, {
        headers: {
            'x-api-key': API_KEY,
            'content-type': 'application/json'
        },
        params: params
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

/**
 * @description returns a list of employee referrals
 * @param {String} employeeId the JV employee Id
 */
const getEmployeeAuthorizations = async (employeeId) => {
    const params = {
        employeeId: employeeId
    }
    const response = await axios.get(`${API_URL}/authorizations/listAuthorizationsByMemberId`, {
        headers: {
            'x-api-key': API_KEY,
            'content-type': 'application/json'
        },
        params: params
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

/************* Clients *************/

/**
 * @description returns all clients in javelina
 */
const getAllClients = async () => {
    const response = await axios.get(`${API_URL}/clients/searchAllClients`, {
        headers: {
            'x-api-key': API_KEY,
            'content-type': 'application/json'
        }
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

/**
 * @description returns all clients for a block of business
 * @param {String} blockOfBusinessId block of business id in JV
 */
const getAllClientsForBlockOfBusiness = async (blockOfBusinessId) => {
    const params = {
        blockOfBusinessId: blockOfBusinessId
    }
    const response = await axios.get(`${API_URL}/clients/searchClientsByBlockOfBusinessId`, {
        headers: {
            'x-api-key': API_KEY,
            'content-type': 'application/json'
        },
        params: params
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

/**
 * @description returns a single client
 * @param {String} blockOfBusinessId block of business id in JV
 * @param {String} clientId client id in JV
 */
const getClient = async (blockOfBusinessId, clientId) => {
    const params = {
        blockOfBusinessId: blockOfBusinessId,
        clientId: clientId
    }
    const response = await axios.get(`${API_URL}/clients/readClientByBlockOfBusinessClientId`, {
        headers: {
            'x-api-key': API_KEY,
            'content-type': 'application/json'
        },
        params: params
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

/************* Claims *************/

/**
 * @description * DEPRECEATED * USE getClaimByMember * returns a list of claims by client alternate id
 * @param {String} alternateID the JV client alt id
 */
const getClaimsByClient = async (alternateID) => {
    const params = {
        alternateID: alternateID
    }
    const response = await axios.get(`${API_URL}/claims/searchClaimsByAlternateID`, {
        headers: {
            'x-api-key': API_KEY,
            'content-type': 'application/json'
        },
        params: params
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

/**
 * @description returns a list of by patientid (employeeId) and dependent sequence number
 * @param {String} patientId the JV employeeId or dependentIda
 */
const getClaimsByMember = async (patientId) => {
    const params = {
        patientId: patientId
    }
    const response = await axios.get(`${API_URL}/claims/searchClaimsByPatientId`, {
        headers: {
            'x-api-key': API_KEY,
            'content-type': 'application/json'
        },
        params: params
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

/**
 * @description returns a response for a first, next or last page request for claims records
 * @param {String} pageLink the JV pagination link
 */
const getClaimsPage = async (pageLink) => {
    const linkSplit = pageLink.split('/');
    const params = {
        token: linkSplit[linkSplit.length - 1]
    }
    const response = await axios.get(`${API_URL}/claims/searchClaimsPagination`, {
        headers: {
            'x-api-key': API_KEY,
            'content-type': 'application/json'
        },
        params: params
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

/**
 * @description returns a claim by claim number with service lines
 * @param {String} claimNumber the JV claim number
 */
const getClaim = async (claimNumber) => {
    const params = {
        claimNumber: claimNumber
    }
    const response = await axios.get(`${API_URL}/claims/readClaimByClaimNumber`, {
        headers: {
            'x-api-key': API_KEY,
            'content-type': 'application/json'
        },
        params: params
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

/**
 * @description returns a combined response for all page requests for claim records, starting with the first "Next" page link.
 * @param {String} nextPageLink the "Next" pagination link from a JV Claim request
 */
const getClaimsAllPages = async (nextPageLink) => {
    let pagination = {
        Next: nextPageLink
    };

    let pagedResponseList = [];
    while (pagination && pagination.Next) {
        pagedResponse = await getClaimsPage(pagination.Next);
        pagedResponseList.push(...pagedResponse.Response.AdjudicationResult);
        pagination = pagedResponse.Response.Pagination;
    }

    return pagedResponseList;
}

/************* Eligibility *************/

/**
 * @description used for activation - adds a pcp for the member for the current effective date
 * @param {String} employeeId the family certificate number
 * @param {String} effectiveDate the family certificate number
 * @param {String} product the family certificate number
 * @param {String} connectorId connector id of the carepoint in JV
 * @param {String} existingPatient existing patient constant
 */
const addEmployeeMedicalPcp = async (employeeId, effectiveDate, product, connectorId, existingPatient) => {
    const body = {
        employeeId: employeeId,
        effectiveDate: effectiveDate,
        product: product,
        connectorId: connectorId,
        existingPatient: existingPatient
    }
    const response = await axios.post(`${API_URL}/eligibility/addMemberPrimaryCareProvider`, body, {
        headers: {
            'x-api-key': API_KEY,
            'content-type': 'application/json'
        }
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

/**
 * @description used for activation - adds a pcp for the dependent for the current effective date
 * @param {String} employeeId the family certificate number
 * @param {String} depSeqNum the family certificate number
 * @param {String} effectiveDate the family certificate number
 * @param {String} product the family certificate number
 * @param {String} connectorId connector id of the carepoint in JV
 * @param {String} existingPatient existing patient constant
 */
const addDependentMedicalPcp = async (employeeId, depSeqNum, effectiveDate, product, connectorId, existingPatient) => {
    const body = {
        employeeId: employeeId,
        depSeqNum: depSeqNum,
        effectiveDate: effectiveDate,
        product: product,
        connectorId: connectorId,
        existingPatient: existingPatient
    }
    const response = await axios.post(`${API_URL}/eligibility/addDependentPrimaryCareProvider`, body, {
        headers: {
            'x-api-key': API_KEY,
            'content-type': 'application/json'
        }
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

/**
 * @description used for updating pcp - updates a pcp for the employee for the current effective date
 * @param {String} employeeId the family certificate number
 * @param {String} effectiveDate the family certificate number
 * @param {String} product the family certificate number
 * @param {String} connectorId connector id of the carepoint in JV
 * @param {String} existingPatient existing patient constant
 */
const updateEmployeeMedicalPcp = async (employeeId, effectiveDate, product, connectorId, existingPatient) => {
    const body = {
        employeeId: employeeId,
        effectiveDate: effectiveDate,
        product: product,
        connectorId: connectorId,
        existingPatient: existingPatient
    }
    const response = await axios.put(`${API_URL}/eligibility/updateMemberPrimaryCareProvider`, body, {
        headers: {
            'x-api-key': API_KEY,
            'content-type': 'application/json'
        }
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

/**
 * @description used for updating pcp - updates a pcp for the dependent for the current effective date
 * @param {String} employeeId the family certificate number
 * @param {String} depSeqNum the family certificate number
 * @param {String} effectiveDate the family certificate number
 * @param {String} product the family certificate number
 * @param {String} connectorId connector id of the carepoint in JV
 * @param {String} existingPatient existing patient constant
 */
const updateDependentMedicalPcp = async (employeeId, depSeqNum, effectiveDate, product, connectorId, existingPatient) => {
    const params = {
        employeeId: employeeId,
        depSeqNum: depSeqNum,
        effectiveDate: effectiveDate,
        product: product,
        connectorId: connectorId,
        existingPatient: existingPatient
    }
    const response = await axios.put(`${API_URL}/eligibility/updateDependentPrimaryCareProvider`, params, {
        headers: {
            'x-api-key': API_KEY,
            'content-type': 'application/json'
        }
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

/**
 * @description sets a paperless preference in JV for claims
 * @param {String} employeeId employee id
 * @param {String} blkOfBusId block of business id
 * @param {String} clientId client id
 * @param {String} preference paperless preference Y or N
 */
const updateEmployeeEobPaperlessPreference = async (employeeId, blkOfBusId, clientId, preference) => {
    const params = {
        employeeId: employeeId,
        blockOfBusinessId: blkOfBusId,
        clientId: clientId,
        eobPaperlessPreference: preference
    }
    const response = await axios.put(`${API_URL}/eligibility/updateMemberPaperlessEobPreference`, params, {
        headers: {
            'x-api-key': API_KEY,
            'content-type': 'application/json'
        }
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

/**
 * @description sets a paperless preference in JV for claims
 * @param {String} employeeId employee id
 * @param {String} depSeqNum dep seq num
 * @param {String} blkOfBusId block of business id
 * @param {String} clientId client id
 * @param {String} preference paperless preference Y or N
 */
const updateDependentEobPaperlessPreference = async (employeeId, depSeqNum, blkOfBusId, clientId, preference) => {
    const params = {
        employeeId: employeeId,
        depSeqNum: depSeqNum,
        blockOfBusinessId: blkOfBusId,
        clientId: clientId,
        eobPaperlessPreference: preference
    }
    const response = await axios.put(`${API_URL}/eligibility/updateDependentPaperlessEobPreference`, params, {
        headers: {
            'x-api-key': API_KEY,
            'content-type': 'application/json'
        }
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

/**
 * @description updates member info in JV
 * @param {String} employeeId employee id
 * @param {String} depSeqNum dep seq num
 * @param {String} blkOfBusId block of business id
 * @param {String} clientId client id
 * @param {String} email email of member
 * @param {String} middleName middle name of member
 * @param {String} lastName last name of member
 * @param {String} mobilePhone mobilePhone of member
 * @param {String} alternateMobilePhone alternateMobilePhone of member
 * @param {String} homePhone mobilePhone of member
 * @param {String} alternateHomePhone alternateHomePhone of member
 * @param {String} workPhone mobilePhone of member
 * @param {String} alternateWorkPhone alternateWorkPhone of member
 */
const updateDependentContactInfo = async (employeeId, depSeqNum, blkOfBusId, clientId, email, middleName, lastName, mobilePhone, alternateMobilePhone, homePhone, alternateHomePhone, workPhone, alternateWorkPhone) => {
    const params = {
        employeeId: employeeId,
        depSeqNum: depSeqNum,
        blockOfBusinessId: blkOfBusId,
        clientId: clientId,
        email: email,
        middleName: middleName,
        lastName: lastName,
        mobilePhone: mobilePhone,
        homePhone: homePhone,
        workPhone: workPhone,
        alternateMobilePhone: alternateMobilePhone,
        alternateHomePhone: alternateHomePhone,
        alternateWorkPhone: alternateWorkPhone
    }
    const response = await axios.put(`${API_URL}/eligibility/updateDependentContactInfo`, params, {
        headers: {
            'x-api-key': API_KEY,
            'content-type': 'application/json'
        }
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

/**
 * @description updates member info in JV
 * @param {String} employeeId employee id
 * @param {String} blkOfBusId block of business id
 * @param {String} clientId client id
 * @param {String} email email of member
 * @param {String} middleName middle name of member
 * @param {String} lastName last name of member
 * @param {String} mobilePhone mobilePhone of member
 * @param {String} alternateMobilePhone alternateMobilePhone of member
 * @param {String} homePhone mobilePhone of member
 * @param {String} alternateHomePhone alternateHomePhone of member
 * @param {String} workPhone mobilePhone of member
 * @param {String} alternateWorkPhone alternateWorkPhone of member
 */
const updateEmployeeContactInfo = async (employeeId, blkOfBusId, clientId, email, middleName, lastName, mobilePhone, alternateMobilePhone, homePhone, alternateHomePhone, workPhone, alternateWorkPhone) => {
    const params = {
        employeeId: employeeId,
        blockOfBusinessId: blkOfBusId,
        clientId: clientId,
        email: email,
        middleName: middleName,
        lastName: lastName,
        mobilePhone: mobilePhone,
        homePhone: homePhone,
        workPhone: workPhone,
        alternateMobilePhone: alternateMobilePhone,
        alternateHomePhone: alternateHomePhone,
        alternateWorkPhone: alternateWorkPhone
    }
    const response = await axios.put(`${API_URL}/eligibility/updateMemberContactInfo`, params, {
        headers: {
            'x-api-key': API_KEY,
            'content-type': 'application/json'
        }
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

/**
 * @description updates address information in JV
 * @param {String} employeeId employee id
 * @param {String} depSeqNum depSeqNum
 * @param {String} effectiveDate effective date of address
 * @param {String} address1 address info
 * @param {String} city city 
 * @param {String} state state (NY)
 * @param {String} zip paperless preference Y or N
 */
const updateDependentAddressInfo = async (employeeId, depSeqNum, effectiveDate, address1, city, state, zip) => {
    const params = {
        employeeId: employeeId,
        depSeqNum: depSeqNum,
        effectiveDate: effectiveDate,
        address1: address1,
        city: city,
        state: state,
        zip: zip
    }
    const response = await axios.put(`${API_URL}/eligibility/updateDependentAddressInfo`, params, {
        headers: {
            'x-api-key': API_KEY,
            'content-type': 'application/json'
        }
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

/**
 * @description updates address information in JV
 * @param {String} employeeId employee id
 * @param {String} effectiveDate effective date of address
 * @param {String} address1 address info
 * @param {String} city city 
 * @param {String} state state (NY)
 * @param {String} zip paperless preference Y or N
 */
const updateEmployeeAddressInfo = async (employeeId, effectiveDate, address1, city, state, zip) => {
    const params = {
        employeeId: employeeId,
        effectiveDate: effectiveDate,
        address1: address1,
        city: city,
        state: state,
        zip: zip
    }
    const response = await axios.put(`${API_URL}/eligibility/updateMemberAddressInfo`, params, {
        headers: {
            'x-api-key': API_KEY,
            'content-type': 'application/json'
        }
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

/**
 * @description returns a list of a family by certificate number
 * @param {String} certificateNumber the family certificate number
 */
const getFamilyByCertificateNumber = async (certificateNumber) => {
    const params = {
        certificateNumber: certificateNumber
    }
    const response = await axios.get(`${API_URL}/eligibility/searchMemberByCertificateNumber`, {
        headers: {
            'x-api-key': API_KEY,
            'content-type': 'application/json'
        },
        params: params
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

/**
 * @description returns of members by blk of bus id and client id
 * @param {String} blkOfBusId the block of business id
 * @param {String} clientId the client Id
 */
const getMembersByBlockOfBusinessIdClientId = async (blockOfBusinessId, clientId) => {
    const params = {
        blockOfBusinessId: blockOfBusinessId,
        clientId: clientId
    }
    const response = await axios.get(`${API_URL}/eligibility/searchMembersByBlockOfBusinessClientId`, {
        headers: {
            'x-api-key': API_KEY,
            'content-type': 'application/json'
        },
        params: params
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

/**
 * @description returns coverage information for an employee
 * @param {String} employeeId the JV employee Id
 * @param {String} effectiveDate the current effective date for the member
 */
const getEmployeeCoverage = async (employeeId, effDate) => {
    const params = {
        employeeId: employeeId,
        effectiveDate: effDate
    }
    const response = await axios.get(`${API_URL}/eligibility/readEmployeeCoverageRecord`, {
        headers: {
            'x-api-key': API_KEY,
            'content-type': 'application/json'
        },
        params: params
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

/**
 * @description returns coverage information for a dependent
 * @param {String} employeeId the JV employee Id
 * @param {String} depSeqNumber the dependent sequence number of the depenent
 * @param {String} effectiveDate the current effective date for the member
 */
const getDependentCoverage = async (employeeId, depSeqNumber, effDate) => {
    const params = {
        employeeId: employeeId,
        depSeqNum: depSeqNumber,
        effectiveDate: effDate
    }
    const response = await axios.get(`${API_URL}/eligibility/readDependentCoverageRecord`, {
        headers: {
            'x-api-key': API_KEY,
            'content-type': 'application/json'
        },
        params: params
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

/**
 * @description returns a list of a family by certificate number
 * @param {String} employeeId the family certificate number
 */
const getEmployee = async (employeeId) => {
    const params = {
        employeeId: employeeId
    }
    const response = await axios.get(`${API_URL}/eligibility/searchMemberByEmployeeId`, {
        headers: {
            'x-api-key': API_KEY,
            'content-type': 'application/json'
        },
        params: params
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

/**
 * @description returns a list of a family by certificate number
 * @param {String} employeeId the family certificate number
 * @param {String} depSeqNum the dependent sequence number
 */
const getDependent = async (employeeId, depSeqNum) => {
    const params = {
        employeeId: employeeId,
        depSeqNum: depSeqNum
    }
    const response = await axios.get(`${API_URL}/eligibility/searchMemberByEmployeeIdDependentSequenceNumber`, {
        headers: {
            'x-api-key': API_KEY,
            'content-type': 'application/json'
        },
        params: params
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

/**
 * @description returns a response for a first, next or last page request for eligibility records
 * @param {String} pageLink the JV pagination link
 */
const getEligibilityPage = async (pageLink) => {
    const linkSplit = pageLink.split('/');
    const params = {
        token: linkSplit[linkSplit.length - 1]
    }
    const response = await axios.get(`${API_URL}/eligibility/searchMembersPagination`, {
        headers: {
            'x-api-key': API_KEY,
            'content-type': 'application/json'
        },
        params: params
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

/**
 * @description returns a combined response for all page requests for eligibility records, starting with the first "Next" page link.
 * @param {String} nextPageLink the "Next" pagination link from a JV Eligibility request
 */
const getEligibilityAllPages = async (nextPageLink) => {
    let pagination = {
        Next: nextPageLink
    };

    let pagedResponseList = [];
    while (pagination && pagination.Next) {
        pagedResponse = await getEligibilityPage(pagination.Next);
        pagedResponseList.push(...pagedResponse.Response.MemberDetails);
        pagination = pagedResponse.Response.Pagination;
    }

    return pagedResponseList;
}

/************* Providers *************/

/**
 * @description returns provider info by NPI
 * @param {String} npi npi of the provider
 */
const getProviderByNpi = async (npi) => {
    const params = {
        npi: npi
    }
    const response = await axios.get(`${API_URL}/provider/searchPhysiciansByNationalProviderID`, {
        headers: {
            'x-api-key': API_KEY,
            'content-type': 'application/json'
        },
        params: params
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

/**
 * @description returns detailed provider info by Javelina Physican Id
 * @param {String} id JV Physican ID 
 */
const getProviderByPhysicianId = async (id) => {
    const params = {
        physicianID: id
    }
    const response = await axios.get(`${API_URL}/provider/getPhysicianByPhysicanID`, {
        headers: {
            'x-api-key': API_KEY,
            'content-type': 'application/json'
        },
        params: params
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

/**
 * @description returns a single facility
 * @param {String} id JV Facility ID 
 */
const getFacilityByFacilityId = async (id) => {
    const params = {
        facilityID: id
    }
    const response = await axios.get(`${API_URL}/provider/getFacilityByFacilityID`, {
        headers: {
            'x-api-key': API_KEY,
            'content-type': 'application/json'
        },
        params: params
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

/**
 * @description returns care points by Javelina physican id
 * @param {String} id JV Physican ID 
 */
const getProviderAffiliationsByPhysicianId = async (id) => {
    const params = {
        physicianID: id
    }
    const response = await axios.get(`${API_URL}/provider/listProviderAffiliationsByPhysicianID`, {
        headers: {
            'x-api-key': API_KEY,
            'content-type': 'application/json'
        },
        params: params
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

/**
 * @description returns care points by Javelina facility id
 * @param {String} id JV Facility ID 
 */
const getProviderAffiliationsByFacilityId = async (id) => {
    const params = {
        facilityID: id
    }
    const response = await axios.get(`${API_URL}/provider/listProviderAffiliationsByFacilityID`, {
        headers: {
            'x-api-key': API_KEY,
            'content-type': 'application/json'
        },
        params: params
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

module.exports = {
    addDependentMedicalPcp,
    addEmployeeMedicalPcp,
    getEmployee,
    getDependent,
    getDependentAuthorizations,
    getEmployeeAuthorizations,
    getFamilyByCertificateNumber,
    getDependentCoverage,
    getEmployeeCoverage,
    getEligibilityPage,
    getEligibilityAllPages,
    getMembersByBlockOfBusinessIdClientId,
    getAllClients,
    getAllClientsForBlockOfBusiness,
    getClient,
    getClaim,
    getClaimsByClient,
    getClaimsByMember,
    getClaimsPage,
    getClaimsAllPages,
    getFamilyAccums,
    getFacilityByFacilityId,
    getProviderByNpi,
    getProviderByPhysicianId,
    getProviderAffiliationsByPhysicianId,
    getProviderAffiliationsByFacilityId,
    loadConstants,
    updateDependentMedicalPcp,
    updateDependentEobPaperlessPreference,
    updateDependentAddressInfo,
    updateDependentContactInfo,
    updateEmployeeMedicalPcp,
    updateEmployeeAddressInfo,
    updateEmployeeContactInfo,
    updateEmployeeEobPaperlessPreference
}
//under construction
// createAuthorization